export enum FileStatus {
	PENDING = 'pending',
	CONFIRMED = 'confirmed',
	FAILED = 'failed',
}

export enum FileSharePermission {
	VIEW = 'view',
	DOWNLOAD = 'download',
}

export enum FileCategory {
	DOCUMENT = 'document',
	IMAGE = 'image',
	SPREADSHEET = 'spreadsheet',
	PRESENTATION = 'presentation',
	AUDIO = 'audio',
	VIDEO = 'video',
	ARCHIVE = 'archive',
	OTHER = 'other',
}

export enum FileProcessingStatus {
	PROCESSING = 'processing',
	COMPLETED = 'completed',
	FAILED = 'failed',
}

export enum FileProcessingResultStatus {
	PENDING = 'pending',
	RUNNING = 'running',
	COMPLETED = 'completed',
	FAILED = 'failed',
}
